module.exports = __webpack_public_path__ + "img/dankort.e6243845.svg";